const state = {
    subcategory: {},
    subcategories: [],
}
const actions = {
    showSubcategories: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/subcategories`).then(response => {
                context.commit('SHOW_SUBCATEGORIES', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showSubcategory: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/subcategories/${id}`).then(response => {
                context.commit('SHOW_SUBCATEGORY', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storeSubcategory: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/subcategories`, payload).then(response => {
                context.commit('STORE_SUBCATEGORY', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateSubcategory: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/subcategories/${payload.id}`, payload).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroySubcategory: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/subcategories/${id}`).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {

    SHOW_SUBCATEGORY: (state, payload) => {
        state.subcategory = payload
    },
    SHOW_SUBCATEGORIES: (state, payload) => {
        state.subcategories = payload
    },
    STORE_SUBCATEGORY: (state, payload) => {
        state.subcategory = payload
    }
}
const getters = {
    subcategory: state => {
        return state.subcategory
    },
    subcategories: state => {
        return state.subcategories
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
